import {createApp} from 'vue';

import { Splitpanes, Pane } from 'splitpanes';

import './style.css';
import 'floating-vue/dist/style.css';

import App from './App.vue';

import { plugin } from '@formkit/vue';
import config from '../formkit.config.js';

import {createPinia} from 'pinia';

import {initAxios} from '@/utils/axios';
import router from '@/routes';
import {createGtm} from '@gtm-support/vue-gtm';

import { Icon } from '@iconify/vue';

import FloatingVue from 'floating-vue';
import WebsocketService from '@/services/websocket';

WebsocketService.init();

const app = createApp(App);

const pinia = createPinia();
app.use(pinia);
app.use(FloatingVue);

app.component('Icon', Icon);
app.component('Splitpanes', Splitpanes);
app.component('Pane', Pane);

initAxios(router);

if (import.meta.env.VITE_ENV === 'production') {
    app.use(
        createGtm({
            id: import.meta.env.VITE_GTM_ID,
            vueRouter: router,
        }),
    );
}

app.use(router);

app.use(plugin, config);

const iconComponents = import.meta.glob('@/components/icons/*.vue', {eager: true});
for (const [key, module] of Object.entries(iconComponents)) {
    const componentName = key.split('/').pop().replace('.vue', '');
    app.component(componentName, module.default);
}

app.mount('#app');
